import * as React from 'react';
import { noop } from '@amzn/storm-ui-utils';
import { PageTitleIconApiResponse } from './ajaxPageTitleIconInfo';

type PageTitleIconToggleType = {
  apiResponse: PageTitleIconApiResponse;
};

type PageTitleIconContextProps = {
  pageTitleIconToggleData: PageTitleIconToggleType | null;
  setPageTitleIconToggleData: (args: PageTitleIconToggleType | null) => void;
};

const PageTitleIconContext = React.createContext<PageTitleIconContextProps>({
  pageTitleIconToggleData: null,
  setPageTitleIconToggleData: noop,
});

export const usePageTitleIconContext = (): PageTitleIconContextProps => {
  const context = React.useContext(PageTitleIconContext);
  if (!context) {
    throw new Error('AttributionContext must be used with AttributionProvider');
  }
  return context;
};

export const PageTitleIconContextProvider: React.FC = ({ children }) => {
  const [pageTitleIconToggleData, setPageTitleIconToggleData] =
    React.useState<PageTitleIconToggleType | null>(null);
  return (
    <PageTitleIconContext.Provider
      value={{ pageTitleIconToggleData, setPageTitleIconToggleData }}
    >
      {children}
    </PageTitleIconContext.Provider>
  );
};
